import {UI} from "../../../stem-core/src/ui/UIBase.js";
import {styleRule, StyleSheet} from "../../../stem-core/src/ui/Style.js";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme.js";
import {Messages} from "../../Messages.js";
import {Link} from "../../../stem-core/src/ui/UIPrimitives.jsx";
import {MerchantButton} from "../../common/MerchantButton.jsx";
import {DONATE_PAGE_URLS} from "../PanelConstants.js";
import {PoweredByBlink} from "../PoweredByBlink.jsx";
import {MISSING_INFO} from "../../Constants.js";
import {DonationStore} from "../../State.js";
import {iFrameMerchantService} from "../../services/IframeMerchantService.js";
import {iFrameUserDataService} from "../../services/IFrameUserDataService.js";
import {MessageElement} from "../../widget/ui/MessageElement.jsx";


class RecurringDonorStyle extends StyleSheet {
    @styleRule
    title = this.themeProps.MERCHANT_TITLE_STYLE;

    @styleRule
    center = {
        margin: "10px 0 20px",
        textAlign: "center",
    };

    @styleRule
    link = this.themeProps.PANEL_LINK;

    @styleRule
    text = {
        marginBottom: 16,
    };
}

@registerStyle(RecurringDonorStyle)
export class RecurringDonorPanel extends UI.Element {
    render() {
        const {styleSheet} = this;
        const publicationName = iFrameMerchantService.getMerchant().name;
        const donation = iFrameUserDataService.getActiveRecurringDonation();

        return [
            <div className={styleSheet.title}>{Messages.donatePageRecurringDonorTitle}</div>,
            <MessageElement className={styleSheet.text} message={Messages.activeDonationDescription2(publicationName)} />,
            <MessageElement className={styleSheet.text} message={Messages.donatePageRecurringDonorInfo(donation.formatPrice())} />,
            <MessageElement className={styleSheet.text} message={Messages.donatePageRecurringDonorNextPayment(
                donation.getNextBillingDate()?.format("MMM DD, YYYY") || MISSING_INFO,
                donation.getPaymentMethod()?.getLastDigits() || MISSING_INFO)}/>,
            <MerchantButton onClick={() => this.options.changeURL(DONATE_PAGE_URLS.donate)}>
                {Messages.makeAnotherDonation}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <Link value={Messages.editRecurringDonation} onClick={() => this.options.changeURL(DONATE_PAGE_URLS.editDonation)}
                      className={styleSheet.link}/>
            </div>,
            <PoweredByBlink />,
        ];
    }

    onMount() {
        this.attachChangeListener(DonationStore, () => {
            if (!iFrameUserDataService.getActiveRecurringDonation()) {
                this.options.changeURL(DONATE_PAGE_URLS.donate);
            }
        })
    }
}
